<template>
  <a
    id="button"
    href="https://store.steampowered.com/app/830660"
    target="_blank"
    class="font-sarala"
  >
    <img src="/fonts/icons/sgz-request-btn.svg" />
  </a>
</template>

<script>
import EventBus from "@/EventBus";

export default {
  name: "SgzButton",
  props: {
    hideAlphaText: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showPopup() {
      EventBus.$emit("toggle-popup", true);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/vars";

#button {
  cursor: pointer;
  padding: 0;
  background: none;
  border: 0;

  img {
    width: 100%;
    height: auto;
    max-width: 100%;
  }
}
</style>
